<template>
  <component
    :is="component"
    v-bind="componentProps"
    class="file-listing"
    :class="{ 'not-valid': isValidateType }"
  >
    <v-tooltip v-if="isValidateType" top z-index="4">
      <template v-slot:activator="{ on }">
        <span v-on="on" class="file-name">
          {{ file.name }}
        </span>
      </template>
      <span>{{ $t('message.willNotSaved') }}</span>
    </v-tooltip>

    <span v-else class="file-name">
      {{ file.name }}
    </span>

    <v-btn v-if="!isLink" x-small dark icon class="ml-2" @click="$emit('remove')">
      <v-icon small>delete</v-icon>
    </v-btn>
  </component>
</template>

<script>
export default {
  props: {
    file: {
      type: [Object, File, FileList],
    },
    type: {
      type: String,
      default: 'file',
      validator(value) {
        return ['file', 'link', 'validate'].indexOf(value) !== -1;
      },
    },
  },
  computed: {
    isLink() {
      return this.type === 'link';
    },
    isValidateType() {
      return this.type === 'validate';
    },
    component() {
      return this.isLink ? 'a' : 'div';
    },
    componentProps() {
      if (this.isLink) {
        return {
          href: this.file.link,
          target: '_blank',
        };
      }

      return {};
    },
  },
};
</script>

<style scoped lang="scss">
.file-listing {
  display: inline-flex;
  padding: 5px;
  border-radius: 3px;
  margin: 12px 12px 0 0;
  text-decoration: blink;
  background: var(--v-borderDocuments-base);

  &.not-valid {
    background: var(--v-error-base);
  }

  .file-name {
    color: #fff;
    padding: 0 5px;
    max-width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    @media screen and (max-width: 400px) {
      max-width: 150px;
    }
  }
}
</style>
